import React from "react";
import { cn } from "@/lib/utils";

function isLightHelmetColor(color) {
  const normalized = String(color || "").trim().toLowerCase();
  return normalized === "#fff" || normalized === "#ffffff" || normalized === "white";
}

export default function HelmetIcon({
  color = "#dc2626",
  className,
  title,
  decorative = true,
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={cn("shrink-0 text-slate-900 dark:text-slate-100", className)}
      role={decorative ? "presentation" : "img"}
      aria-hidden={decorative ? "true" : undefined}
      aria-label={!decorative && title ? title : undefined}
      xmlns="http://www.w3.org/2000/svg"
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M11.8 2.6 1.9 6.9l8.4 2.8-.7 5.7c-1.4.8-3.3 1.2-5 1l-1.7-1.8-1.5 1.5v3.7l2.8 1.7c2.9-2.3 6.4-3.8 10-4.5l5.9-1.1c1.1-.2 1.9-1.6 1.9-3.7v-1.7c0-4.3-2.7-7.2-7-7.9l-3.2-.1Z"
        fill={color}
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <path
        d="m5.7 7.1 2.5 1.4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
      />
      <path
        d="m5.5 6.9 2.4 1.3"
        fill="none"
        stroke="currentColor"
        strokeWidth="0.9"
        strokeLinecap="round"
      />
      <path
        d="m6 5.4 1.8 1.1-2.2.8-1.9-.6Z"
        fill="rgba(255,255,255,0.94)"
        stroke="currentColor"
        strokeWidth="0.9"
        strokeLinejoin="round"
      />
    </svg>
  );
}
